// extracted by mini-css-extract-plugin
export default {"def":"_type_def__DLvSH","fill":"_type_fill__EVDTX","dense":"_type_dense__boJwa"};